// Configuración de puntos para el juego de memoria
export const GAME_POINTS = {
  MEMORY: {
    MATCH_PAIR: 20,      // Puntos base por encontrar un par (aumentado de 10 a 20)
    COMPLETE_LEVEL: 60,  // Bonus por completar el nivel (aumentado de 50 a 60)
    PERFECT_TIME: 30,    // Bonus por completar en menos de 60 segundos (aumentado de 25 a 30)
    NO_MISTAKES: 40,     // Bonus por completar sin errores (aumentado de 30 a 40)
    MIN_POINTS: 100      // Mínimo para ganar Cerebrix
  }
} as const;

// Constantes del sistema de Cerebrix
export const CEREBRIX_CONSTANTS = {
  POINTS_PER_CEREBRIX: 100,  // Puntos necesarios para ganar 1 Cerebrix
  DAILY_LIMIT: 20,           // Límite diario de Cerebrix
  MEMORY_GAME: {
    BASE_CEREBRIX: 1,        // Cerebrix base por completar el juego
    PERFECT_BONUS: 2,        // Bonus por juego perfecto (sin errores)
    SPEED_BONUS: 1,          // Bonus por completar en tiempo óptimo
    CATEGORY_BONUS: 1,       // Bonus por completar una categoría
    MAX_CEREBRIX: 5          // Máximo de Cerebrix por sesión
  }
} as const;

// Configuración de tiempo y dificultad
export const GAME_CONFIG = {
  TIME_LIMIT: 120,           // 2 minutos por juego
  PERFECT_TIME: 60,          // Tiempo para bonus perfecto (1 minuto)
  DIFFICULTY_LEVELS: {
    BASIC: {
      PAIRS: 8,              // 8 pares de cartas
      TIME_BONUS: 1.2        // Multiplicador de puntos por tiempo
    },
    INTERMEDIATE: {
      PAIRS: 12,             // 12 pares de cartas
      TIME_BONUS: 1.5        // Multiplicador de puntos por tiempo
    },
    ADVANCED: {
      PAIRS: 16,             // 16 pares de cartas
      TIME_BONUS: 2.0        // Multiplicador de puntos por tiempo
    }
  }
} as const;
